import {logs} from '@opentelemetry/api-logs';

import type {OtelLoggerState} from './types';

export const INVALID_TRACE_ID = '00000000000000000000000000000000';
export const INVALID_SPAN_ID = '0000000000000000';

export const OTEL_LOGS_PATH = '/v1/logs';
export const OTEL_LOGGER_SCOPE_NAME = 'zoefin-logger';

export const LOG_ATTRIBUTE_COUNT_LIMIT = 128;
export const LOG_SCHEDULED_DELAY_MS = 1000;
export const LOG_EXPORT_TIMEOUT_MS = 5000;
export const LOG_EXPORTER_CONCURRENCY_LIMIT = 10;
export const PENDING_SDK_LOG_LIMIT = 256;

export const OTEL_LOGGER_STATE: OtelLoggerState = {
  edgeLogBuffer: [],
  hasWarnedMissingLoggerProvider: false,
  otelLogger: logs.getLogger(OTEL_LOGGER_SCOPE_NAME),
  pendingSdkLogBuffer: [],
};
